import React from "react";
import styles from "../BrokerCRM/BrokerCRM.module.css";
import logo from "../../assets/mm-logo.png"; // ✅ correct path

export default function ClientTopNav() {
  return (
    <div className={styles.crmTopNavWrap}>
      <div className={styles.crmTopNav}>
        
        {/* Logo */}
        <a href="/" className={styles.crmBrand}>
          <img src={logo} alt="Mortgage Matrix" className={styles.crmLogo} />
        </a>

        <div className={styles.crmNavActions}>
          {/* Desktop Phone */}
          <a
            href="tel:1300537267"
            className={`${styles.crmPhonePill} ${styles.crmHideMobile}`}
          >
            <span className={styles.crmPhoneIcon}>📞</span>
            1300 537 267
          </a>

          {/* Desktop Book */}
          <a
            href="/book"
            className={`${styles.crmBookBtn} ${styles.crmHideMobile}`}
          >
            Book Appointment
          </a>

          {/* Mobile Phone */}
          <a
            href="tel:1300537267"
            className={`${styles.crmIconBtn} ${styles.crmShowMobile}`}
          >
            📞
          </a>

          {/* Mobile Book */}
          <a
            href="/book"
            className={`${styles.crmIconBtn} ${styles.crmIconBtnBook} ${styles.crmShowMobile}`}
          >
            📅
          </a>
        </div>
      </div>
    </div>
  );
}